import { useShowUnavailableProductsStore } from '../showUnavailableProducts.store';
import useCanChangeAdminOptions from './useCanChangeAdminOptions';

const useIsAdminSeller = () => {
  const canChangeAdminOptions = useCanChangeAdminOptions();
  const showUnavailableProducts = useShowUnavailableProductsStore(
    (state) => state.showUnavailableProducts,
  );

  return canChangeAdminOptions && !showUnavailableProducts;
};

export default useIsAdminSeller;
